import { $theme } from './themeStore';
import type { Theme } from './themeStore';

const STORAGE_KEY = 'pilgrim.theme';

const META_COLORS: Record<Theme, string> = {
  dark: '#050507',
  light: '#ffffff',
};

$theme.watch((t) => {
  try {
    localStorage.setItem(STORAGE_KEY, t);
  } catch {
    /* private mode */
  }

  document.documentElement.setAttribute('data-theme', t);
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', META_COLORS[t]);
});
